
export default {
  props: {
    productName: {
      type: String,
      default: ''
    },
    productBrand: {
      type: String,
      default: ''
    }
  }
}
